import { toast } from 'react-toastify';
import { SeverityLevel } from '@microsoft/applicationinsights-web';
import { appInsights } from '@/App';

export function isLocalDev(): boolean {
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.hostname === '') {
      return true;
  }
  return false;
}

const APP_FULL_NAME = 'SM-WEB-APP';

function isError(error: any) {
  if (Object.prototype.toString.call(error) === '[object Error]' && error && error.stack && error.message) {
    return true;
  }

  return false;
}
export class Logger {
  public static info(message: unknown, properties: Record<string, unknown> = {}): void {
    try {
      const obj = {
        message,
        severityLevel: SeverityLevel.Information,
        properties: {
          ...properties,
          info: '',
          itemType: APP_FULL_NAME,
        },
      };

      if (isLocalDev()) {
        console.log(message);
        return;
      }

      if (appInsights) {
        // @ts-ignore
        appInsights.trackTrace(obj);
      }
    } catch (e) {
      console.error(e);
    }
  }

  public static warn(message: unknown): void {
    try {
      const obj = {
        message,
        severityLevel: SeverityLevel.Warning,
        properties: { info: '', itemType: APP_FULL_NAME },
      };

      if (isLocalDev()) {
        console.warn(obj);
        return;
      }

      if (appInsights) {
        // @ts-ignore
        appInsights.trackTrace(obj);
      }
    } catch (e) {
      console.error(e);
    }
  }

  public static error(error: Error | any, properties: Record<string, unknown> = {}): void {
    try {
      const obj = {
        exception: error,
        properties: {
          ...properties,
          info: isError(error) ? error.stack : '',
          itemType: APP_FULL_NAME,
        },
        severityLevel: SeverityLevel.Error,
      };

      if (isLocalDev()) {
        console.error(obj);
        return;
      }

      if (appInsights) {
        appInsights.trackException(obj);
      }
    } catch (e) {
      console.error(e);
    } finally {
      if (isError(error)) {
        toast.error(`An error occurred : ${error.message}`);
      }
    }
  }

  public static event(name: string, properties: Record<string, unknown>): void {
    try {
      const obj = {
        name,
        properties: { ...properties, itemType: APP_FULL_NAME },
        severityLevel: SeverityLevel.Information,
      };

      if (isLocalDev()) {
        console.log(obj);
        return;
      }

      if (appInsights) {
        appInsights.trackEvent(obj);
      }
    } catch (e) {
      console.error(e);
    }
  }
}

export type LogLevels = keyof Omit<typeof Logger, 'prototype'>;
